import React, { useState } from "react";

export default function Step1({ formData, updateFormData, nextStep }) {
  const [errors, setErrors] = useState({});

  const handleNext = () => {
    const newErrors = {};
    if (!formData?.name?.trim()) newErrors.name = "Обязательное поле";
    if (!formData?.email?.trim()) newErrors.email = "Обязательное поле";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      nextStep();
    }
  };

  const handleChange = (field, value) => {
    updateFormData({ [field]: value });
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  return (
    <div className="form-inner">
      <h2 className="form-title">Заполните контактные данные</h2>

      <div className="input-group">
        <label>Ваше ФИО</label>
        <input
          type="text"
          placeholder="Иван Иванов"
          value={formData?.name || ""}
          onChange={(e) => handleChange("name", e.target.value)}
          className={errors.name ? "input-field error" : "input-field"}
        />
        {errors.name && <span className="error-msg">{errors.name}</span>}
      </div>

      <div className="input-group">
        <label>Ваш email</label>
        <input
          type="email"
          placeholder="bilPay@gmail.com"
          value={formData?.email || ""}
          onChange={(e) => handleChange("email", e.target.value)}
          className={errors.email ? "input-field error" : "input-field"}
        />
        {errors.email && <span className="error-msg">{errors.email}</span>}
      </div>

<div className="form-footer-right">
        <span className="step-text">Шаг: 1/3</span>
        <div className="nav-buttons-group">
          <button className="btn-next" onClick={handleNext}>Далее →</button>
                </div>
      </div>
      
    </div>
  );
}
